import React from "react";
import { Box, makeStyles } from "@material-ui/core";
import { capitalize } from "helpers/algoliaUtils";
import { SubcategoriesStaticData } from "data/categories";

export default function MobileMenu({ items, refine, createURL }) {
  const classes = useStyle();
  items = items && items.find((item) => item.isRefined) ? items.find((item) => item.isRefined).items : items;
  return items?.length ? (
    <Box className={classes.container}>
      {items.map((item, index) => (
        <Box
          key={item.label}
          height={24}
          pr={index === items.length - 1 ? 3 : 0}
          className={item.isRefined ? classes.refinedItem : classes.item}
        >
          <span
            role="button"
            tabIndex={0}
            href={createURL(item.value)}
            onKeyDown={() => {}}
            onClick={(event) => {
              event.preventDefault();
              refine(item.value);
            }}
          >
            {SubcategoriesStaticData.find((cat) => cat.slug === item.label)?.name || capitalize(item.label)}
          </span>
        </Box>
      ))}
    </Box>
  ) : null;
}

const useStyle = makeStyles((theme) => ({
  container: {
    marginRight: 2,
    display: "flex",
    fontSize: 17,
    fontWeight: 500,
    width: "max-content",
    borderBottom: "1px solid rgba(215, 215, 215, 0.6);",
  },
  refinedItem: {
    marginLeft: 16,
    paddingBottom: 16,
    height: "auto",
    borderBottom: "4px solid #1A8E96",
  },
  item: {
    color: theme.palette.grey700.main,
    marginLeft: 16,
    paddingBottom: 16,
  },
}));
